export default __webpack_public_path__ + "static/media/BN.aae99526.svg";